
import CriarUsuario from "../components/CriarUsuario";

export default {
  name: "usuarios",

  data: () => ({
    usuarios: [],
    loading: false,
    page: 1,
    itemsPerPage: 5,
    pesquisaUsuario: "",
  }),

  components: {
    CriarUsuario,
  },

  computed: {
    usuariosFiltrados() {
      const normalizar = (texto) => String(texto || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      const termo = normalizar(this.pesquisaUsuario).trim();
      return termo ? this.usuarios.filter((usuario) => normalizar(usuario.nome).includes(termo)) : this.usuarios;
    },
    length() {
      return Math.ceil(this.usuariosFiltrados.length / this.itemsPerPage);
    },
    usuariosPorPagina() {
      const inicio = (this.page - 1) * this.itemsPerPage;
      return this.usuariosFiltrados.slice(inicio, inicio + this.itemsPerPage);
    },
  },

  watch: {
    pesquisaUsuario() {
      this.page = 1;
    },
  },

  mounted() {
    this.getUsuarios();
  },

  methods: {
    getUsuarios() {
      this.loading = true;
      this.$http
        .get(`/usuarios`)
        .then((res) => {
          this.usuarios = res.data;
        })
        .catch((err) => {
          alert(err);
        })
        .finally(() => (this.loading = false));
    },

    setPermissaoVendas(valor, usuario) {
      this.setPermissao({ vendas: valor ? 1 : 0 }, usuario);
    },
    setPermissaoAnalise(valor, usuario) {
      this.setPermissao({ analise: valor ? 1 : 0 }, usuario);
    },
    setPermissaoContratos(valor, usuario) {
      this.setPermissao({ contratos: valor ? 1 : 0 }, usuario);
    },
    setPermissaoRelatorios(valor, usuario) {
      this.setPermissao({ relatorios: valor ? 1 : 0 }, usuario);
    },
    setPermissaoCancelamento(valor, usuario) {
      this.setPermissao({ cancelamento: valor ? 1 : 0 }, usuario);
    },
    setPermissaoUsuarios(valor, usuario) {
      this.setPermissao({ usuarios: valor ? 1 : 0 }, usuario);
    },

    setPermissao(data, usuario) {
      this.$http
        .put(`/usuarios/${usuario}`, data)
        .finally(() => this.getUsuarios());
    },
  },
};
